import { CompanySchema } from '@terra/shared-schemas-orchestrator';
import { z } from 'zod';

export const AllCompaniesReturnSchema = z.object({
  companies: z.array(
    CompanySchema.pick({ id: true, name: true, tenantId: true }),
  ),
});

export const CompanyReturnSchema = z.object({
  company: CompanySchema,
});

export const CompanyParamsSchema = z.object({
  companyName: z.string(),
});

export const CompanyProvisionBodySchema = z.object({
  domain: z.string().min(1),
});

export const CompanyProvisionResponseSchema = z.object({
  accepted: z.boolean(),
});
